<h1 mat-dialog-title>Formulario para crear etiqueta</h1>

<mat-dialog-content>
  <form [formGroup]="form" (submit)="onSave()">
    <span *ngIf="isEditDialog">
      <mat-slide-toggle formControlName="addSalesOrder"
        >Agregar sales order</mat-slide-toggle
      >
      <mat-form-field appearance="outline">
        <mat-label>Sales Order</mat-label>
        <mat-select formControlName="salesOrder">
          <mat-option>
            <ngx-mat-select-search
              [formControl]="searchSalesOrder"
              placeholderLabel="Buscar..."
              noEntriesFoundLabel="Sin resultados"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="undefined">Limpiar</mat-option>
          <mat-option
            *ngFor="let item of filterSalesOrder"
            [value]="item.transactionId"
            >{{ item.title }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </span>

    <mat-form-field appearance="outline" class="tw-my-2">
      <mat-label>Work Order</mat-label>
      <mat-select formControlName="workOrder">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="searchWorkOrder"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="undefined">Limpiar</mat-option>
        <mat-option *ngFor="let item of filterListWorkOrders" [value]="item.id"
          >{{ item.title }}
        </mat-option>
      </mat-select>
      <mat-hint
        >Primero selecciona un numero de parte para luego seleccionar la
        WO</mat-hint
      >
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Numero de etiquetas</mat-label>
      <input matInput type="number" formControlName="numLabels" />
      <mat-hint>Se refiere a cuantas etiquetas deseas imrpimir</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Cantidad</mat-label>
      <input matInput type="number" formControlName="quantity" />
    </mat-form-field>
    <!--    <mat-form-field *ngIf="showLotNumber" appearance="outline" class="tw-my-2">-->
    <!--      <mat-label>Numeros de Lote</mat-label>-->
    <!--      <mat-select formControlName="lotNumber">-->
    <!--        <mat-option *ngFor="let lot of data.lotNumbers" [value]="lot">{{-->
    <!--          lot-->
    <!--        }}</mat-option>-->
    <!--      </mat-select>-->
    <!--    </mat-form-field>-->
  </form>
</mat-dialog-content>

<mat-dialog-actions class="flex tw-justify-between">
  <div *ngIf="isEditDialog">
    <button class="btn-reject" mat-raised-button (click)="onRejected()">
      Rechazar
    </button>
  </div>
  <div>
    <button class="app-btn-close" mat-raised-button mat-dialog-close>
      Cancelar
    </button>
    <button
      mat-raised-button
      [disabled]="form.invalid"
      [class.app-btn-save]="form.valid"
      (click)="onSave()"
    >
      Guardar
    </button>
  </div>
</mat-dialog-actions>
